export default "__VITE_ASSET__B325RFRU__"